import React, { useState, useEffect } from "react";
import { FaUpload, FaTrashAlt } from "react-icons/fa";
import { toast } from "react-toastify";
import { uploadImage } from "../utils/imageUpload";
import { API_BASE_URL } from "../config/apiConfig";

const ImageUploader = ({
  imageUrl,
  onImageChange,
  folder,
  label = "Foto",
  accept = "image/*",
}) => {
  const [previewImage, setPreviewImage] = useState(null);
  const [isUploading, setIsUploading] = useState(false);

  // Actualizar previewImage cuando imageUrl cambia
  useEffect(() => {
    if (imageUrl) {
      if (!imageUrl.startsWith("http") && !imageUrl.startsWith("/")) {
        // Es un nombre de archivo, construir la URL
        setPreviewImage(`${API_BASE_URL}/downloads/${folder}/${imageUrl}`);
      } else {
        // Es una URL completa
        setPreviewImage(imageUrl);
      }
    } else {
      setPreviewImage(null);
    }
  }, [imageUrl, folder]);

  const handleImageChange = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    setIsUploading(true);

    try {
      const uniqueFilename = await uploadImage(file, folder);

      // Actualizar el estado del componente padre
      onImageChange(uniqueFilename);

      // Crear preview
      const reader = new FileReader();
      reader.onload = (e) => {
        setPreviewImage(e.target.result);
      };
      reader.readAsDataURL(file);
    } catch (error) {
      console.error("Error al subir la imagen:", error);
      toast.error(
        error.message ||
          "Error al subir la imagen. Por favor, inténtalo de nuevo."
      );
    } finally {
      setIsUploading(false);
    }
  };

  const eliminarImagen = () => {
    onImageChange(null);
    setPreviewImage(null);
    // Limpiar el input file
    const fileInput = document.getElementById(`image-input-${folder}`);
    if (fileInput) {
      fileInput.value = "";
    }
  };

  return (
    <div className="campo column">
      <label className="verde mayusculas">{label}</label>
      <div className="upload-foto">
        {!previewImage ? (
          <div className="upload-area">
            <input
              type="file"
              id={`image-input-${folder}`}
              accept={accept}
              onChange={handleImageChange}
              style={{ display: "none" }}
              disabled={isUploading}
            />
            <label htmlFor={`image-input-${folder}`} className="upload-label">
              <FaUpload className="upload-icon" />
              <span>{isUploading ? "Subiendo..." : "Subir imagen"}</span>
              <small>JPG, PNG, GIF (máx. 5MB)</small>
            </label>
          </div>
        ) : (
          <div className="preview-foto">
            <img src={previewImage} alt="Preview" className="foto-preview" />
            <button
              type="button"
              onClick={eliminarImagen}
              className="eliminar-foto"
              aria-label="Eliminar imagen"
              disabled={isUploading}
            >
              <FaTrashAlt />
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default ImageUploader;
